export function checkValidDate(dateString) {
  const datePatternDMY = /^(0?[1-9]|[12][0-9]|3[01])\/(0?[1-9]|1[0-2])\/\d{4}$/;
  const datePatternYMD = /^\d{4}-(0?[1-9]|1[0-2])-(0?[1-9]|[12][0-9]|3[01])$/;

  if (datePatternDMY.test(dateString)) {
    const [day, month, year] = dateString.split("/").map(Number);
    return isValidDayMonthYear(day, month, year);
  } else if (datePatternYMD.test(dateString)) {
    const [year, month, day] = dateString.split("-").map(Number);
    return isValidDayMonthYear(day, month, year);
  }

  return false; // Doesn't match any of the expected formats
}

export function checkValidOldDate(dateString) {
  // Check if the date is after the min date (01/01/1900)
  const minDate = new Date("1900-01-01");
  if (new Date(dateString) < minDate) {
    return true;
  }
  return false;
}
function isValidDayMonthYear(day, month, year) {
  if (year < 1000 || year > 9999 || month === 0 || month > 12) {
    return false;
  }

  const daysInMonth = [31, 28, 31, 30, 31, 30, 31, 31, 30, 31, 30, 31];
  const isLeapYear = (year % 4 === 0 && year % 100 !== 0) || year % 400 === 0;

  if (month === 2) {
    if (isLeapYear && (day < 1 || day > 29)) {
      return false; // Invalid day for February in a leap year
    } else if (!isLeapYear && (day < 1 || day > 28)) {
      return false; // Invalid day for February in a non-leap year
    }
  } else if (day < 1 || day > daysInMonth[month - 1]) {
    return false; // Day is out of range for the given month
  }

  return true;
}
